import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/not_found404.webp")